import React from 'react';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';

const GrillCapacity = ({
  grillFeatureLabels,
  grillCapacity,
  maxTemp,
  pelletHopperCapacity,
  totalCookingSpace,
  totalWeight,
}) => {
  if (!grillFeatureLabels) return null;

  return (
    <>
      {grillCapacity && (
        <div className="flex flex-col gap-x-6 justify-center my-10 sm:flex-row items-center sm:items-stretch">
          {grillCapacity.map((x, i) => (
            <React.Fragment key={i}>
              <div className="flex flex-row align-center sm:flex-col">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={buildImageSrc(x.icon, 32, 0, 0)}
                  role="presentation"
                  alt=""
                  className="h-10 pr-3 sm:pr-0"
                />

                <span>
                  <p className="tra-text-web-heading-6 text-center pr-2">{x.amount}</p>
                </span>
                <span>
                  <p className="tra-text-web-body-l font-bold">{x.foodTitle}</p>
                </span>
              </div>
              {i < grillCapacity.length - 1 && (
                <div className="flex items-center">
                  <p className="tra-text-web-body-s uppercase font-bold">
                    {grillFeatureLabels.orText}
                  </p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
      <dl className="grid grid-cols-[2fr_1fr] gap-x-8 gap-y-2 mb-10 max-w-sm mx-auto sm:px-16 sm:max-w-lg md:max-w-md lg:px-8">
        <dt>{grillFeatureLabels.totalCookingSpace}</dt>
        <dd className="font-bold">{totalCookingSpace}</dd>
        <dt>{grillFeatureLabels.totalWeight}</dt>
        <dd className="font-bold">{totalWeight}</dd>
        <dt>{grillFeatureLabels.hopperCapacity}</dt>
        <dd className="font-bold">{pelletHopperCapacity}</dd>
        <dt>{grillFeatureLabels.maxTemp}</dt>
        <dd className="font-bold">{maxTemp}</dd>
      </dl>
    </>
  );
};

export default GrillCapacity;
